"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductSearch = void 0;
class ProductSearch {
    static init() {
        let timer;
        const waitTime = 100;
        const searchInput = document.querySelector("#searchForm input[name='s']");
        const resultsList = document.querySelector('.search-results ul');
        if (searchInput) {
            searchInput.addEventListener('keydown', () => {
                clearTimeout(timer);
            });
            searchInput.addEventListener('keyup', () => {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    search();
                }, waitTime);
            });
            const search = async () => {
                const text = searchInput.value;
                const ajax_url_post = window.woocommerce_params.ajax_url + '?action=getProductMatches&input=' + text;
                if (text !== '') {
                    resultsList.style.display = 'block';
                    resultsList.innerHTML = '';
                    try {
                        const response = await fetch(ajax_url_post, {
                            method: 'POST',
                        });
                        const results = await response.json();
                        showResults(results);
                    }
                    catch (error) {
                        console.error(error);
                    }
                }
                else {
                    resultsList.style.display = 'none';
                }
            };
            const showResults = (results) => {
                if (resultsList) {
                    const maxResults = 6;
                    resultsList.innerHTML = '';
                    let i = 0;
                    results.forEach((result) => {
                        if (i < 6) {
                            resultsList.innerHTML +=
                                '<li class="single-result"><a href="' +
                                    result.url +
                                    '"><img src="' +
                                    result.image +
                                    '" /><span>' +
                                    result.title +
                                    '</span></a></li>';
                        }
                        i++;
                    });
                    if (results.length === 0) {
                        resultsList.innerHTML = '<span>Geen resultaten gevonden</span>';
                    }
                    else {
                        const amount = results.length > maxResults ? maxResults : results.length;
                        resultsList.innerHTML +=
                            '<span class="amount">' +
                                amount +
                                ' van ' +
                                results.length +
                                ' resultaten</span>' +
                                '<a href="?s=' +
                                searchInput.value +
                                '&post_type=product" class="overview-link">Bekijk producten</a>';
                    }
                }
            };
        }
    }
}
exports.ProductSearch = ProductSearch;
